if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /* Lookup address
        *
        * Lookup for postalcode + housenumber = address
        *
        * expects:
        * <someelement data-interaction="LookupAddress" data-lookup-url="url_of_lookup_webservice">
        * <input data-lookup-id="postalcode">
        * <input data-lookup-id="housenumber">
        * <input data-lookup-id="streetname">
        * <input data-lookup-id="city">
        * <someelement data-lookup-id="result"></someelement>
        * */
        ZZ.LookupAddress = function(inputsContainer) {
            var base = this;
            base.container = inputsContainer;
            base.formValidationHandler = new ZZ.FormValidationHandler();

            base.postalcodeInput = base.container.find(
                "[data-lookup-id=postalcode]"
            );
            base.housenrInput = base.container.find(
                "[data-lookup-id=housenumber]"
            );
            base.housenrInputAddition = base.container.find(
                "[data-lookup-id=housenumber_addition]"
            );

            base.addressContainer = base.container.find(
                "[data-lookup-id=result]"
            );
            base.lookupUrl = base.container.attr("data-lookup-url");
            base.submittype = base.container.attr("data-lookup-type") || "GET";

            base.streetHiddenInput = base.container.find(
                "[data-lookup-id=streetname][type=hidden]"
            );
            base.cityHiddenInput = base.container.find(
                "[data-lookup-id=city][type=hidden]"
            );
            base.curExceptions = base.container
                .find("[data-validate-if]")
                .attr("data-validate-if");

            base.setMailException();

            base.assignListeners();

            // trigger lookup script on init, for when the info is already prefilled
            if ($.trim(base.postalcodeInput.val()) !== "") {
                base.postalcodeInput.trigger("blur");
            }
        };

        ZZ.LookupAddress.prototype = {
            setMailException: function() {
                var base = this;

                if (base.curExceptions) {
                    var curEx = base.curExceptions.split("=");
                    base.exField = $(curEx[0]);
                    base.exValue = curEx[1];
                    var exceptionTrigger = $(
                            "[name=" + base.exField.attr("name") + "]"
                        ),
                        relatedInput = base.container.find(
                            "[data-validate-if]"
                        ),
                        relatedLabelSpan = relatedInput
                            .closest(".form-row")
                            .find("label span");

                    exceptionTrigger.on("change", function() {
                        if (
                            typeof base.exField.attr("checked") === "undefined"
                        ) {
                            base.formValidationHandler.fieldIsValid(
                                relatedInput
                            );
                            relatedLabelSpan.hide();
                        } else {
                            relatedLabelSpan.show();
                            if (relatedInput.val().length > 0) {
                                relatedInput.blur();
                            }
                        }
                    });

                    exceptionTrigger.change();
                }
            },

            assignListeners: function() {
                var base = this,
                    inputs = base.container.find("input[data-lookup-id]");

                base.container.on(
                    "ZZ-cancel-edit-toggle",
                    this.cancel.bind(this)
                );

                inputs.on("blur", function() {
                    inputs.removeClass("error");
                    $(inputs[0])
                        .parent()
                        .removeClass("error");

                    if (inputs.filter("[data-validate]").length > 0) {
                        //only validate the field which is changed
                        // inputs.filter('[data-validate]').trigger('blur.validate');
                    } else {
                        base.lookupAddress();
                    }
                });

                // check lookup after validation - custom event from formvalidation.js
                inputs
                    .filter("[data-validate]")
                    .on("ZZ_validate_done", function() {
                        if (
                            (base.postalcodeInput.val() !== "" &&
                                base.housenrInput.val() !== "") ||
                            (base.postalcodeInput.val() === "" &&
                                base.housenrInput.val() === "")
                        ) {
                            base.lookupAddress();
                        }
                    });
            },

            lookupAddress: function() {
                var base = this;

                base.addressContainer.html("");

                window.setTimeout(function() {
                    // allow for a small timeout for allowing focus in next input field
                    if (base.checkConditions()) {
                        base.updateAddress();
                    }
                }, 50);
            },

            // check various conditions must pass before executing address lookup
            checkConditions: function() {
                var base = this,
                    notEqualToPlaceholder = true,
                    noValidationErrors = true,
                    notRequiredAndNotEmpty = true,
                    requiredAndNoFocus = true,
                    required = true,
                    notEmpty =
                        $.trim(base.postalcodeInput.val()) !== "" &&
                        $.trim(base.housenrInput.val()) !== "";

                if (
                    typeof base.postalcodeInput.attr("placeholder") !==
                    "undefined"
                ) {
                    notEqualToPlaceholder =
                        base.postalcodeInput.val() !==
                        base.postalcodeInput.attr("placeholder");
                }
                if (
                    notEqualToPlaceholder &&
                    typeof base.housenrInput.attr("placeholder") !== "undefined"
                ) {
                    notEqualToPlaceholder =
                        base.housenrInput.val() !==
                        base.housenrInput.attr("placeholder");
                }

                // if postalcode needs to be validated before querying address lookup
                if (
                    typeof base.postalcodeInput.attr("data-validate") !==
                    "undefined"
                ) {
                    noValidationErrors =
                        !base.postalcodeInput.hasClass("error") &&
                        !base.housenrInput.hasClass("error");
                }

                if (base.exField && base.exField.length) {
                    // if address is required on form
                    required = base.exField.attr("checked") === base.exValue;

                    // if address is not a required element on form, only update if inputs are not empty
                    notRequiredAndNotEmpty =
                        !required && notEqualToPlaceholder && notEmpty;

                    // if address is required, and postcode and housenumber have no in field focus
                    requiredAndNoFocus =
                        required &&
                        !base.postalcodeInput.is(":focus") &&
                        !base.housenrInput.is(":focus");
                }

                return (
                    notEqualToPlaceholder &&
                    noValidationErrors &&
                    (requiredAndNoFocus || notRequiredAndNotEmpty)
                );
            },

            updateAddress: function() {
                var base = this;

                base.addressContainer.addClass("loading");
                $.ajax({
                    url: base.lookupUrl,
                    dataType: "json",
                    type: base.submittype,
                    data:
                        "validate-adres=true&" +
                        base.postalcodeInput.serialize() +
                        "&" +
                        base.housenrInput.serialize(),
                    redirLogout: true /* redirect in case logged out (redirect-proxy.js) */,

                    success: function(response) {
                        base.addressContainer.removeClass("loading");

                        // if 'message' is defined, then an error occurred
                        if (typeof response.street == "undefined") {
                            // let ZZ.FormValidationHandler function handle error
                            if (typeof response.validation !== "undefined") {
                                base.formValidationHandler.fieldIsInvalid(
                                    base.postalcodeInput,
                                    response.validation
                                );
                            }
                            base.addressContainer.html("");
                            base.streetHiddenInput.val("");
                            base.cityHiddenInput.val("");
                        } else {
                            var street = response.street,
                                city = response.city,
                                postalcode = base.formatPostalcode(
                                    base.postalcodeInput.val()
                                ),
                                housenumberAddition = base.housenrInputAddition.val();

                            base.formValidationHandler.removeFieldValidation(
                                base.postalcodeInput
                            );

                            base.streetHiddenInput.val(street);
                            base.cityHiddenInput.val(city);
                            if ($.trim(postalcode) !== "") {
                                base.postalcodeInput.val(postalcode);
                            }
                            if (
                                housenumberAddition ===
                                base.housenrInputAddition.attr("placeholder")
                            ) {
                                housenumberAddition = "";
                            }

                            var addressPreview = street;
                            addressPreview += " " + base.housenrInput.val();
                            addressPreview +=
                                " " +
                                housenumberAddition
                                    .replace(/</g, "&lt;")
                                    .replace(/>/g, "&gt;") +
                                "<br>";
                            addressPreview += postalcode;
                            addressPreview += " " + city;
                            base.addressContainer.html(addressPreview);
                        }
                    },

                    error: function() {
                        base.addressContainer.removeClass("loading");
                    }
                });
            },

            formatPostalcode: function(postalcode) {
                var tempPostalcode = $.trim(postalcode).toUpperCase(),
                    postalLeftside,
                    postalRigthside;

                tempPostalcode = tempPostalcode.replace(/ /g, "");
                postalLeftside = tempPostalcode.substr(0, 4);
                postalRigthside = tempPostalcode.substr(
                    tempPostalcode.length - 2,
                    2
                );

                tempPostalcode = postalLeftside + " " + postalRigthside;
                return tempPostalcode;
            },

            cancel: function() {
                this.addressContainer.html("");
            }
        };
    })(jQuery);
}
